import { render, staticRenderFns } from "./CentroCustosFilter.vue?vue&type=template&id=1bb7d820"
import script from "./CentroCustosFilter.vue?vue&type=script&lang=js"
export * from "./CentroCustosFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports